export default "__VITE_ASSET__BDJzY9tX__"